const oneTrustLauncher = document.querySelector(".js-onetrust-launcher");
if (oneTrustLauncher) {
	const domainScript = oneTrustLauncher.dataset.domainScript;
	const language = oneTrustLauncher.dataset.language;

	if (window.parent.location.hostname.indexOf("www.raja") > -1 && window.location.hostname.indexOf("group") == -1 ) {
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
		script.setAttribute("data-domain-script", domainScript);
		script.setAttribute("data-language", language);
		script.setAttribute("charset", "UTF-8");
		script.setAttribute("async", true);
		document.getElementsByTagName("head")[0].appendChild(script);
	}
}